// extracted by mini-css-extract-plugin
export default {"modal":"Baeksulgi_modal__pFCEI","modal-backdrop":"Baeksulgi_modal-backdrop__xziIW","modal-body":"Baeksulgi_modal-body__cdjLr"};